import {
  AccountRepository,
  UserRepository,
  RuntimeRepository
} from "core/repository";
import { Base2Presenter } from "core/presenter";
import { BaseService } from "core/service";
import { SignUpConstraint } from "core/constraint";
import validate from "validate.js";

class SignUpPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      success: false,
      form: {
        submitted: false,
        fields: {
          companyName: "",
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          phone: ""
        },
        errors: {
          companyName: "",
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          phone: ""
        }
      }
    };
  }

  async onFormSubmit() {
    const { fields } = this.viewModel.form;

    const params = {
      user: {
        name: fields.name,
        username: fields.email,
        password: fields.password,
        metadata: {},
        locale: "pt_BR"
      },
      company: {
        name: fields.companyName,
        slug: fields.companyName,
        phone: fields.phone,
        email: fields.email,
        segment: "",
        fiscal_informations: {},
        default_tip: { code: "GORJ", name: "Gorjeta", amount: 0 }
      },
      locale: "pt_BR"
    };

    const isValid = this.onValidate();

    if (!isValid) {
      return;
    }

    this.enqueue({ loading: true });

    const response = await AccountRepository.createAccount(params);

    if (response.success) {
      const signInResponse = await UserRepository.signIn(
        params.user.username,
        params.user.password
      );

      if (signInResponse.success) {
        this.mRuntime.set(
          RuntimeRepository.props.currentUser,
          signInResponse.data.user
        );
        this.mRuntime.set(
          RuntimeRepository.props.token,
          signInResponse.data.token
        );
        BaseService.config({ authorizationToken: signInResponse.data.token });
        this.redirectToLogin();
      } else {
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content: signInResponse.error
        });
      }
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: response.error
      });
    }

    this.enqueue({ loading: false });
  }

  redirectToLogin() {
    this.navigateTo("app.login");
  }

  onValidate() {
    const { fields } = this.viewModel.form;

    const constraint = SignUpConstraint.signUp;
    const validation = validate(fields, constraint, { fullMessages: false });

    if (!!validation) {
      const errors = Object.entries(validation)
        .map(([field, error]) => ({ field, content: error[0] }))
        .reduce(
          (vmErrors, error) => ({ [error.field]: error.content, ...vmErrors }),
          {}
        );

      this.enqueue(vm => ({ form: { ...vm.form, errors } }));

      return false;
    } else {
      this.enqueue(vm => ({ form: { ...vm.form, errors: {} } }));

      return true;
    }
  }

  onSubmitted() {
    this.enqueue(vm => ({
      form: {
        ...vm.form,
        submitted: true
      }
    }));
  }

  handleFieldChange(field, value) {
    this.enqueue(vm => ({
      form: {
        ...vm.form,
        fields: {
          ...vm.form.fields,
          [field]: value
        }
      }
    }));
  }
}

export default SignUpPresenter;



// WEBPACK FOOTER //
// ./src/components/app/sign-up/presenter.js